<template>
    <v-dialog v-model="show" width="600" content-class="modal modal-round">

        <div class="close" @click="show = false">&times;</div>

        <button class="btn btn-primary btn-extra-round" slot="activator" @click="reset">
            Liberar/Bloquear conexão
        </button>

        <v-card :key="id">

            <app-free-connections-form ref="body"
                                          v-model="data"
                                          @input="input"
                                          @valid="save"></app-free-connections-form>

            <div class="card-footer">
                <button class="btn btn-primary btn-round" @click="validateRelease()">
                    Liberar conexão
                </button>
                <button class="btn btn-primary btn-round" @click="validateBlock()">
                    Bloquear conexão
                </button>
            </div>

        </v-card>

    </v-dialog>
</template>

<script>
    import AppFreeConnectionsForm from './components/FreeConnectionsForm'
    import EventBus from '@packages/event-bus'
    import _ from 'lodash'

    export default {
        components: {
            AppFreeConnectionsForm
        },

        data() {
            return {
                show: false,
                edit: false,
                id: null,
                data: {
                    acao: '',
                },
            }
        },

        computed: {
            devices() {
                return this.$store.state.devices.list
            },

        },

        methods: {
            validateRelease() {
                this.data.acao = 'LIBERAR'
                this.$refs.body.validate()
            },

            validateBlock(){
                this.data.acao = 'BLOQUEAR'
                this.$refs.body.validate()
            },

            async save() {
                await this.$api.freeconnections.create(this.data)

                EventBus.$emit(`LOAD_FREECONNECTIONS`)
                this.show = false
            },

            reset() {
                this.edit = false
                this.id = null
                this.data = {
                    mac: '',
                    descricao : '',
                    aparelhoId: ''
                }
            },

            input(value) {
                this.data = value
            },

            editFreeConnectionsHandler(id, mac, descricao) {
                this.data = _.cloneDeep(_.find(this.advertising, (advertising) => {
                    return advertising.id === id
                }))
                this.show = true
                this.edit = true
                this.id = id
                this.data.mac = mac;
                this.data.descricao = descricao;
            }
        },

        watch: {
            show(show) {
                if (show)
                    this.$nextTick(() => EventBus.$emit('RESET_FREECONNECTIONS_MODAL'))
            }
        },

        mounted() {
            EventBus.$on('edit-freeconnections', this.editFreeConnectionsHandler)
        },

        beforeDestroy() {
            EventBus.$off('edit-freeconnections', this.editFreeConnectionsHandler)
        },
    }
</script>

<style lang="scss" scoped>
    @import "~@variables";

    .card-footer {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 15px;

        .btn {
            margin: 15px;
        }
    }

    .modal-round .v-card .card-body {
        min-height: 200px;
    }

</style>
